import Cookies from 'universal-cookie';

const COOKIES_NOT_INITIALISED_ERROR = 'Cookies not initialised';

let _cookies: Cookies | undefined;

export function initialiseCookies(cookiesObj?: Cookies): void {
  if (cookiesObj) {
    _cookies = cookiesObj;
  } else {
    _cookies = new Cookies();
  }
}

export function getCookies(): Cookies {
  if (!_cookies) {
    throw new Error(COOKIES_NOT_INITIALISED_ERROR);
  }
  return _cookies;
}

export function hasCookies(): boolean {
  return !!_cookies;
}
